import React from 'react'
import PropTypes from 'prop-types'
import { Label } from 'semantic-ui-react'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const CodeListItem = props => {
  const { item } = props
  return (
    <div className={cx('item')}>
      <Label className={cx('code')}>{item.value}</Label>
      <Label className={cx('description')}>{item.data}</Label>
    </div>
  )
}

CodeListItem.propTypes = {
  item: PropTypes.object.isRequired,
}

export default CodeListItem
